<script setup lang="ts">
import useDevice from "~/composables/useDevice";
import usePromoTracking from "~/composables/tracking/usePromoTracking";
import useTrackingContext from "~/composables/tracking/useTrackingContext";
import LinkComponent from "~/templates/components/cms/LinkComponent.vue";
import { containsLink, getImageAlt, imagePath } from "~/utils/helper/magnolia";

// todo: correct type needs to be defined
export interface PromoBannerSlideProps {
  column: object; // Magnolia object
}

const props = defineProps<PromoBannerSlideProps>();

const { isMobile } = useDevice();

useTrackingContext("PromoBanner");

const promoBannerColumn = ref(null);
const { trackPromoView, trackPromoClick } = usePromoTracking({
  promoIndex: props?.column["@name"],
  creativeName: props?.column?.commonLabel["@name"],
  promoName: "promo_banner",
});

const isLink = computed(
  () =>
    containsLink(props.column?.differentMobileContent?.link) || containsLink(props.column?.link),
);

onMounted(() => {
  if (isLink.value) {
    trackPromoView(promoBannerColumn);
  }
});
</script>

<template>
  <img
    v-if="column?.differentMobileContent?.icon || column?.icon"
    :src="
      imagePath(
        isMobile && column?.differentMobileContent?.icon
          ? column?.differentMobileContent?.icon
          : column?.icon,
      )
    "
    :alt="
      getImageAlt(
        isMobile && column?.differentMobileContent?.icon
          ? column?.differentMobileContent?.icon
          : column?.icon,
      )
    "
    class="h-5 w-5"
  />
  <LinkComponent
    ref="promoBannerColumn"
    :link="
      isMobile && column?.differentMobileContent?.link
        ? column?.differentMobileContent?.link
        : column?.link
    "
    class="ml-2"
    @click="isLink && trackPromoClick()"
  >
    {{
      isMobile && column?.differentMobileContent?.commonLabel
        ? column?.differentMobileContent?.commonLabel?.value
        : column?.commonLabel?.value
    }}</LinkComponent
  >
</template>
